import Skeleton from "react-loading-skeleton";

import { Badge2 } from "@/ui2/atoms/Badge";
import type { CosignatureStatusParam } from "@/core/types";
import { Tab2 } from "@/ui2/atoms/Tab";
import { useNeedsReviewQueue } from "@/features/cosignature/api/queries/useNeedsReviewQueue";

type NeedsReviewTabProps = {
  cosignature_status?: CosignatureStatusParam;
  supervisor_id?: string;
};

export function NeedsReviewTab({ cosignature_status, supervisor_id }: NeedsReviewTabProps) {
  const { data, isLoading } = useNeedsReviewQueue({ cosignature_status, supervisor_id });

  return (
    <Tab2 id="needs-review">
      {({ isSelected }) => (
        <>
          Needs Review
          {isLoading ? (
            <CounterBadgeSkeleton />
          ) : (
            <Badge2
              appearance={isSelected ? "solid" : "outline"}
              size="xs"
              variant={isSelected ? "bright-green" : "neutral"}
            >
              {data?.length ?? 0}
            </Badge2>
          )}
        </>
      )}
    </Tab2>
  );
}

function CounterBadgeSkeleton() {
  return (
    <div className="tw:leading-none">
      <Skeleton className="tw:rounded-xs!" height={16} width={20} />
    </div>
  );
}
